import type { ISpecSections } from '../../spec/SpecSections';

/**
 * Class representing a FIX field section type.
 * Stores and manages section-specific information for FIX fields.
 */
export class SectionType {
    /** The unique identifier for the section */
    public sectionID: string | undefined = undefined;
    /** The name of the section */
    public name: string | undefined = undefined;
    /** The order in which the section should be displayed */
    public displayOrder: number | undefined = undefined;
    /** The volume this section belongs to */
    public volume: string | undefined = undefined;
    /** Whether this section is not required in XML */
    public notReqXML: boolean | undefined = undefined;
    /** The FIXML file name associated with this section */
    public fixmlFileName: string | undefined = undefined;
    /** A description of the section */
    public description: string | undefined = undefined;

    /**
     * Sets the section properties based on the provided section specification.
     *
     * @param {ISpecSections} section - The section specification to set
     */
    public setSection(section: ISpecSections): void {
        this.sectionID = section.SectionID;
        this.name = section.Name;
        this.displayOrder = section.DisplayOrder;
        this.volume = section.Volume;
        this.notReqXML = section.NotReqXML === 1;
        this.fixmlFileName = section.FIXMLFileName;
        this.description = section.Description;
    }

    /**
     * Resets all section properties to undefined.
     */
    public reset(): void {
        this.sectionID = undefined;
        this.name = undefined;
        this.displayOrder = undefined;
        this.volume = undefined;
        this.notReqXML = undefined;
        this.fixmlFileName = undefined;
        this.description = undefined;
    }
}
